/**
 * 活动主题类型
 */
export enum ActivityUndertakeTypeEnums {
  /** 送话费-橙色 */
  PHONE_BILL = 'phoneBill',
  /** 7天单车卡-橙色 */
  BIKE_CARD_7 = 'bikeCard7',
  /** 顺风车券包-橙色 */
  CARPOOL_COUPON_PACKAGE = 'carpoolCouponPackage',
  /** 借贷活动-橙色 */
  LOAN_ACTIVITY = 'loanActivity',
  /** 30天免息活动-蓝色 */
  INTEREST_FREE_ACTIVITY = 'interestFreeActivity',
}

/** 主题活动-承接页面类型 */
export enum ActivityPageTypeEnums {
  /** 首页 */
  HOME = 'home',
  /** 资料页 */
  VERIFY_CREDIT = 'verifyCredit',
}
